<div *transloco="let t">
  <div class="form-group row mb-4 ml-1 items-center">
    <ISwitchButton
      [options]="[SelectionModes.Bulk, SelectionModes.FromKeywordSegment]"
      [buttonTexts]="[t('add-keyword-tracking-modal.keyword_list'), t('add-keyword-tracking-modal.keyword_segments')]"
      [buttonTooltips]="['', '']"
      [selected]="selectionMode"
      (buttonClicked)="changeKeywordSelectionMode($event)"
    ></ISwitchButton>
  </div>
  <div class="flex flex-row">
    <div class="row mx-1 w-1/2">
      @if (selectionMode === SelectionModes.Bulk) {
        <div class="h-full w-full">
          <textarea
            [(ngModel)]="bulkKeywords"
            placeholder="{{ t('add-keyword-tracking-modal.keyword_input_placeholder') }}"
            aria-label="Keywords list text area"
            class="h-[35rem]"
          ></textarea>
          <div class="m-1 flex w-full justify-end">
            <button iButton (click)="addKeyword()" [disabled]="keywordToAddInvalid()">{{ t("common.add") }}</button>
          </div>
        </div>
      }
      @if (selectionMode === SelectionModes.FromKeywordSegment) {
        <div class="h-full">
          <div class="h-full">
            <div class="pr-1 pb-0 pl-1">
              <span
                class="select-button-box inline-block pl-3"
                [iTooltip]="
                  selectedKeywordSegments().length === keywordSegments().length
                    ? t('add-keyword-tracking-modal.unselect_all_segments')
                    : t('add-keyword-tracking-modal.select_all_keyword')
                "
              >
                @if (selectedKeywordSegments().length !== keywordSegments().length) {
                  <IIcon name="square" class="text-lg" (click)="selectAllKeywordSegments()" />
                }
                @if (selectedKeywordSegments().length === keywordSegments().length) {
                  <IIcon name="squareCheck" class="text-lg" (click)="unselectAllKeywordSegments()" />
                }
              </span>
              <div iInputGroup>
                <IIcon name="search" />
                <input
                  iInputGroupInput
                  class="w-full"
                  [placeholder]="t('add-keyword-tracking-modal.search_keyword')"
                  [ngModel]="''"
                  (ngModelChange)="setKeywordSegmentFilter($event)"
                />
              </div>
            </div>
            <div class="kw-segments mt-2 mb-3 rounded-sm border pr-1 pl-1">
              @for (keywordSegment of filteredKeywordSegments(); track keywordSegment) {
                <div class="mb-2 w-full">
                  <div
                    class="flex pt-2 pb-2 pl-3"
                    [class.disabledKwSegments]="
                      getKeywordSegmentItems(keywordSegment).length === 0 ||
                      keywordSegmentAlreadySelected(keywordSegment)
                    "
                  >
                    @if (!keywordSegmentAlreadySelected(keywordSegment)) {
                      <span
                        class="select-button-box"
                        [iTooltip]="t('add-keyword-tracking-modal.select_keyword_tooltip', [keywordSegment.name])"
                        (click)="selectKeywordSegment(keywordSegment)"
                      >
                        <IIcon
                          class="text-lg"
                          [name]="isKeywordSegmentSelected(keywordSegment) ? 'squareCheck' : 'square'"
                        />
                      </span>
                    }
                    @if (getKeywordSegmentItems(keywordSegment).length === 0) {
                      <span
                        class="select-button-box"
                        [iTooltip]="t('add-keyword-tracking-modal.no_keyword_tooltip', [keywordSegment.name])"
                      >
                        <IIcon name="square" class="text-lg" />
                      </span>
                    }
                    @if (
                      getKeywordSegmentItems(keywordSegment).length > 0 && keywordSegmentAlreadySelected(keywordSegment)
                    ) {
                      <span
                        class="select-button-box"
                        [iTooltip]="t('add-keyword-tracking-modal.already_tracked_error', [keywordSegment.name])"
                      >
                        <IIcon name="square" class="text-lg" />
                      </span>
                    }
                    <p
                      class="kw-segment-content inline-block w-85 pl-3"
                      (click)="openKeywordSegmentInfo(keywordSegment)"
                      [iTooltip]="
                        t('add-keyword-tracking-modal.open_segment_info_tooltip', {
                          count: getKeywordSegmentItems(keywordSegment).length,
                          name: keywordSegment.name,
                        })
                      "
                    >
                      {{ keywordSegment.name }}
                    </p>
                  </div>
                </div>
              }
            </div>
            <div class="float-right">
              <span [iTooltip]="t('add-keyword-tracking-modal.add_kw_from_segment')">
                <button
                  iButton
                  class="mx-1"
                  (click)="addKeywordByKeywordSegment()"
                  [disabled]="isKeywordSegmentAddButtonDisabled()"
                >
                  {{ t("common.add") }}
                </button>
              </span>
              <ng-content select="[productSegment]"></ng-content>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="selection-arrow mx-2">
      <div class="flex h-full w-full items-center justify-center">
        <IIcon
          name="arrowRight"
          class="arrow pointer text-lg"
          (click)="selectionMode === SelectionModes.FromKeywordSegment ? addKeywordByKeywordSegment() : addKeyword()"
        />
      </div>
    </div>
    <div class="w-1/2 overflow-auto shadow-xs">
      @for (keyword of keywordList; track keyword) {
        <div class="flex flex-row justify-between">
          <div class="text-gray-700">{{ keyword }}</div>
          <div class="mr-3">
            <span
              (click)="deleteKeyword(keyword)"
              [iTooltip]="t('add-keyword-tracking-modal.do_not_track')"
              iTooltipPlacement="left"
              class="cursor-pointer"
            >
              <IIcon name="trash" />
            </span>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="flex w-full justify-end gap-2 bg-white p-4" *transloco="let t">
    <button iButton variant="secondary" size="md" (click)="modalRef.close()">{{ t("common.cancel") }}</button>

    <button iButton type="submit" size="md" [disabled]="!canSave()" (click)="onSave()">
      {{ t("common.save") }}
    </button>
  </div>
</div>
